<div class="video-modal">
  <div class="modal-wrapper">
    <div class="video-content">
      <video #aiBuilderVideo autoplay [muted]="false" playsinline loop
             disablepictureinpicture disableremoteplayback
             controlsList="nodownload noplaybackrate noremoteplayback nofullscreen" width="100%" controls>
        <source src="assets/videos/copilot.mp4" type="video/mp4">
      </video>
    </div>
  </div>
</div>
